import { createRouter, createWebHistory, RouterView } from 'vue-router'

import SignIn from '@/views/SignIn.vue'
import IdentityNumberTestView from '@/views/test_views/IdentityNumberTestView.vue'
import GenderTestView from '@/views/test_views/GenderTestView.vue'
import DateTestView from '@/views/test_views/DateTestView.vue'
import DatePickerMultipleTestView from '@/views/test_views/DatePickerMultipleTestView.vue'
import DatePickerRangeTestView from '@/views/test_views/DatePickerRangeTestView.vue'
import EmailTestView from '@/views/test_views/EmailTestView.vue'
import SelectTestView from '@/views/test_views/SelectTestView.vue'
import MsisdnTestView from '@/views/test_views/MsisdnTestView.vue'
import TextTestView from '@/views/test_views/TextTestView.vue'
import FileUploadTestView from '@/views/test_views/FileUploadTestView.vue'
import StarRatingTestView from '@/views/test_views/StarRatingTestView.vue'
import FormsTestView from '@/views/test_views/FormsTestView.vue'
import { useUserStore } from '@/stores/userStore'
import { useCustomerStore } from '@/stores/customerStore'
import AppConfig from '~/config/appConfig.js'
import GhostboxTestView from '@/views/test_views/GhostboxTestView.vue'

const router = createRouter({
  history: createWebHistory(AppConfig.runtime.basePath),
  routes: [
    {
      path: '',
      name: 'home',
      component: () => import('@/views/home/HomeView.vue'),
      children: []
    },
    {
      path: '/agri_sub_contracts',
      name: 'agri_sub_contracts',
      redirect: '/agri_sub_contracts/prospects',
      component: RouterView,
      children: [
        {
          path: 'prospects',
          name: 'agri_sub_contract_prospects',
          component: () => import('@/views/agri_sub_contracts/prospects/IndexView.vue'),
        },
        {
          path: 'add_contract',
          name: 'agri_sub_contract_add_contract',
          component: () => import('@/views/agri_sub_contracts/prospects/AddContractView.vue'),
        },
        {
          path: 'technical_assessments',
          name: 'agri_sub_contract_technical_assessments_index',
          component: () => import('@/views/agri_sub_contracts/technical_assessments/IndexView.vue'),
        },
        {
          path: ':uuid/first-visit',
          name: 'agri_sub_contract_first_visit',
          component: () => import('@/views/agri_sub_contracts/FirstVisitView.vue'),
          props: true,
        },
        {
          path: ':uuid/contract',
          name: 'agri_sub_contract_contract',
          component: () => import('@/views/agri_sub_contracts/ContractView.vue'),
          props: true,
        },
        {
          path: ':uuid/technical_assessments/:phase',
          name: 'agri_sub_contract_technical_assessments_show',
          component: () => import('@/views/agri_sub_contracts/technical_assessments/ShowView.vue'),
          redirect: to => { return { name: 'agri_sub_contract_technical_assessments_phase_technical_visit', params: { uuid: to.params.uuid, phase: to.params.phase } }; },
          props: true,
          children: [
            {
              path: 'technical_visit',
              name: 'agri_sub_contract_technical_assessments_phase_technical_visit',
              component: () => import('@/views/agri_sub_contracts/technical_assessments/task/TechnicalVisitView.vue'),
            },
            {
              path: 'land_preparation',
              name: 'agri_sub_contract_technical_assessments_phase_land_preparation',
              component: () => import('@/views/agri_sub_contracts/technical_assessments/task/LandPreparationView.vue'),
            },
            {
              path: 'extra',
              name: 'agri_sub_contract_technical_assessments_phase_extra',
              component: () => import('@/views/agri_sub_contracts/technical_assessments/task/ExtraView.vue'),
            },
            {
              path: 'seedlings_transplant',
              name: 'agri_sub_contract_technical_assessments_phase_seedlings_transplant',
              component: () => import('@/views/agri_sub_contracts/technical_assessments/task/SeedlingsTransplantView.vue'),
            },
            {
              path: 'growth_harvest',
              name: 'agri_sub_contract_technical_assessments_phase_growth_harvest',
              component: () => import('@/views/agri_sub_contracts/technical_assessments/task/GrowthHarvestView.vue'),
            },
            {
              path: 'applications',
              name: 'agri_sub_contract_technical_assessments_phase_applications',
              component: () => {
                const userStore = useUserStore()
                if (userStore.partner?.group_code === 'hr') {
                  return import('@/views/agri_sub_contracts/technical_assessments/task/ApplicationsView.vue')
                }
                return import('~/src/views/agri_sub_contracts/technical_assessments/task/ApplicationsViewAgri.vue')
              },
            },
            {
              path: 'recommendations',
              name: 'agri_sub_contract_technical_assessments_phase_recommendations',
              component: () => import('@/views/agri_sub_contracts/technical_assessments/task/RecommendationsView.vue'),
            },
            {
              path: 'phase_complete',
              name: 'agri_sub_contract_technical_assessments_phase_complete',
              component: () => import('@/views/agri_sub_contracts/technical_assessments/task/PhaseCompleteView.vue'),
            },
          ]
        }
      ]
    },
    {
      path: '/prospects',
      name: 'prospects',
      children: [
        {
          path: '',
          name: 'prospects_index',
          component: () => import('@/views/prospects/IndexView.vue')
        },

        {
          path: ':uuid',
          name: 'prospects_show',
          component: () => import('@/views/prospects/ShowView.vue'),
          props: true
        },

        {
          path: ':uuid/edit/:active_index?',
          name: 'prospects_edit',
          component: () => import('@/views/prospects/EditView.vue'),
          props: true
        },
        {
          path: 'create',
          name: 'prospects_create',
          component: () => import('@/views/prospects/CreateView.vue')
        },
        {
          path: 'existing',
          name: 'existing_select',
          component: () => import('@/views/prospects/ExistingSelectView.vue')
        },
        {
          path: 'existing/:customer_uuid',
          name: 'existing_form',
          component: () => import('@/views/prospects/ExistingView.vue')
        },
      ]
    },
    {
      path: '/auth',
      name: 'sign_in',
      component: SignIn,
      children: [
        {
          path: '',
          name: 'welcome',
          component: () => import('@/views/sign_in/WelcomeView.vue')
        },
        {
          path: 'login',
          name: 'request_otp',
          component: () => import('@/views/sign_in/MobileNumberView.vue')
        },
        {
          path: 'validate_otp',
          name: 'validate_otp',
          component: () => import('@/views/sign_in/OTPView.vue')
        },
        {
          path: 'register',
          name: 'register',
          component: () => import('@/views/sign_in/RegisterView.vue')
        },
        {
          path: 'select_partner',
          name: 'select_partner',
          component: () => import('@/views/sign_in/SelectPartnerView.vue')
        }
      ]
    },
    {
      path: '/first_sign_in',
      name: 'first_sign_in',
      component: () => import('@/views/sign_in/InitialSignInView.vue')
    },
    {
      path: '/tests',
      name: 'tests',
      component: () => import('@/views/TestView.vue'),
      children: [
        { path: 'identity_number', component: IdentityNumberTestView },
        { path: 'gender', component: GenderTestView },
        { path: 'date_picker', component: DateTestView },
        { path: 'date_picker_multiple', component: DatePickerMultipleTestView },
        { path: 'date_picker_range', component: DatePickerRangeTestView },
        { path: 'date_picker', component: DateTestView },
        { path: 'email', component: EmailTestView },
        { path: 'select', component: SelectTestView },
        { path: 'msisdn', component: MsisdnTestView },
        { path: 'text', component: TextTestView },
        { path: 'file_upload', component: FileUploadTestView },
        { path: 'star_rating', component: StarRatingTestView },
        { path: 'forms', component: FormsTestView },
        { path: 'ghostbox', component: GhostboxTestView }
      ]
    },
    {
      path: '',
      component: () => import('@/views/LayoutView.vue'),
      children: [
        {
          path: 'academy',
          name: 'academy',
          children: [
            {
              path: '',
              name: 'academy_index',
              component: () => import('@/views/academy/IndexView.vue')
            },
            {
              path: ':uuid',
              name: 'academy_show',
              component: () => import('@/views/academy/ShowView.vue'),
              props: true
            },
            {
              path: ':uuid/edit/:active_index?',
              name: 'academy_edit',
              component: () => import('@/views/academy/EditView.vue'),
              props: true
            },
            {
              path: 'create',
              name: 'academy_create',
              component: () => import('@/views/academy/CreateView.vue')
            },
            {
              path: ':uuid/farmers/:active_index?',
              name: 'academy_farmers',
              component: () => import('@/views/academy/FarmersView.vue'),
              props: true
            },
          ]
        },
        {
          path: 'financial_outcomes',
          name: 'financial_outcomes_index',
          component: () => import('@/views/financial_outcomes/IndexView.vue')
        },
        {
          path: 'farmers',
          name: 'farmers',
          children: [
            {
              path: '',
              name: 'farmers_index',
              component: () => import('@/views/farmers/IndexView.vue'),
              beforeEnter: (to, from, next) => {
                const userStore = useUserStore()
                if (['grow_za', 'growdev_za'].includes(userStore.partner?.code)) {
                  next({ name: 'home' })
                  return
                }
                next()
              }
            },

            {
              path: ':uuid',
              name: 'farmers_show',
              component: () => import('@/views/farmers/ShowView.vue'),
              props: true
            },

            {
              path: ':uuid/edit/:active_index?',
              name: 'farmers_edit',
              component: () => import('@/views/farmers/EditView.vue'),
              props: true
            },
            {
              path: 'create',
              name: 'farmers_create',
              component: () => import('@/views/farmers/CreateView.vue')
            },
            {
              path: 'soil_test/:customer_uuid/:uuid',
              name: 'soil_test_show',
              component: () => import('@/views/farmers/partners/grow/soil_test/ShowView.vue'),
              props: true
            },
            {
              path: 'soil_test/:customer_uuid',
              name: 'soil_test_create',
              component: () => import('@/views/farmers/partners/grow/soil_test/CreateView.vue')
            },
          ]
        },
        {
          path: 'input_orders',
          name: 'input_orders',
          children: [
            {
              path: '',
              name: 'input_orders_index',
              component: () => import('@/views/input_orders/IndexView.vue')
            },

            {
              path: ':orderUuid',
              name: 'input_orders_show',
              component: () => import('@/views/input_orders/ShowView.vue'),
              props: true
            },

            {
              path: ':uuid/edit/:active_index?',
              name: 'input_orders_edit',
              component: () => import('@/views/input_orders/EditView.vue'),
              props: true
            },
            {
              path: 'create',
              name: 'input_orders_create',
              component: () => import('@/views/input_orders/CreateView.vue')
            },
            {
                path: ':uuid/payment/',
                name: 'input_orders_payment',
                component: () => import('@/views/input_orders/partners/unada_ug/create/PaymentVerificationView.vue'),
            }
          ]
        },
        {
          path: 'deliveries',
          name: 'deliveries',
          children: [
            {
              path: '',
              name: 'deliveries_index',
              component: () => import('@/views/deliveries/IndexView.vue')
            },

            {
              path: ':deliveryUuuid',
              name: 'deliveries_show',
              component: () => import('@/views/deliveries/ShowView.vue'),
              props: true
            },

            {
              path: ':uuid/edit/:active_index?',
              name: 'deliveries_edit',
              component: () => import('@/views/deliveries/EditView.vue'),
              props: true
            },
            {
              path: 'create',
              name: 'deliveries_create',
              component: () => import('@/views/deliveries/CreateView.vue')
            },
            {
              path: 'pay/:uuid',
              name: 'deliveries_pay',
              component: () => import('@/views/deliveries/PayView.vue')
            },
            {
              path: 'verify_payment/:uuid',
              name: 'payment_verification',
              component: () => import('@/views/deliveries/PaymentVerificationView.vue')
            }
          ]
        },
        {
          path: 'farms',
          name: 'farms',
          children: [
            {
              path: '',
              name: 'farms_index',
              component: () => import('@/views/farms/IndexView.vue')
            },
            {
              path: ':uuid',
              name: 'farms_show',
              component: () => import('@/views/farms/ShowView.vue'),
              props: true
            },

            {
              path: ':uuid/edit/:active_index?',
              name: 'farms_edit',
              component: () => import('@/views/farms/EditView.vue'),
              props: true
            },
            {
              path: 'create',
              name: 'farm_create_no_customer_route',
              component: () => import('@/views/farms/CreateView.vue')
            },
            {
              path: 'create/:customer_uuid',
              name: 'farms_create',
              component: () => import('@/views/farms/CreateView.vue')
            }
          ]
        },
        {
          path: 'fields',
          name: 'fields',
          children: [
            {
              path: '',
              name: 'fields_index',
              component: () => import('@/views/fields/IndexView.vue')
            },
            {
              path: ':uuid',
              name: 'fields_show',
              component: () => import('@/views/fields/ShowView.vue'),
              props: true
            },
            {
              path: ':uuid/edit/:active_index?',
              name: 'fields_edit',
              component: () => import('@/views/fields/EditView.vue'),
              props: true
            },
            {
              path: 'create/:farm_uuid',
              name: 'fields_create',
              component: () => import('@/views/fields/CreateView.vue')
            },
            {
              path: 'activity',
              name: 'fields_activity_index',
              component: () => import('@/views/farmers/partners/grow/ActivitiesIndexView.vue'),
              props: true
            },
            {
              path: 'activity/create',
              name: 'fields_activity_create',
              component: () => import('@/views/farmers/partners/grow/AddActivityView.vue'),
              props: true
            },
            {
              path: 'activity/questions',
              name: 'fields_activity_questions',
              component: () => import('@/views/farmers/partners/grow/CreateActivityView.vue'),
              props: true
            }
          ]
        },
        {
          path: 'assessments',
          name: 'assessments',
          children: [
            // {
            //   path: '',
            //   name: 'assessments_index',
            //   component: () => import('@/views/assessments/IndexView.vue')
            // },
            {
              path: ':uuid',
              name: 'assessments_show',
              component: () => import('@/views/assessments/ShowView.vue'),
              props: true
            },

            {
              path: ':uuid/edit/:active_index?',
              name: 'assessments_edit',
              component: () => import('@/views/assessments/EditView.vue'),
              props: true
            },
            {
              path: 'create/:customer_uuid/:target_uuid',
              name: 'assessments_create',
              component: () => import('@/views/assessments/CreateView.vue')
            }
          ]
        },
        {
          path: 'surveys',
          name: 'surveys',
          children: [
            {
              path: '',
              name: 'surveys_index',
              component: () => import('@/views/surveys/IndexView.vue')
            },
            {
              path: ':survey_uuid',
              name: 'surveys_show',
              component: () => import('@/views/surveys/ShowView.vue'),
              // props: true,
              children: []
            }
          ]
        },
        {
          path: 'responses/:survey_uuid',
          // name: 'responses',
          children: [
            {
              path: '',
              name: 'responses_index',
              component: () => import('@/views/survey_responses/IndexView.vue')
            },
            {
              path: ':response_uuid',
              name: 'responses_show',
              component: () => import('@/views/survey_responses/ShowView.vue'),
              props: true
            },

            {
              path: 'create',
              name: 'responses_create',
              component: () => import('@/views/survey_responses/CreateView.vue')
            },
            {
              path: 'edit/:response_uuid',
              name: 'responses_edit',
              component: () => import('@/views/survey_responses/EditView.vue'),
              props: true
            }
          ]
        },
        {
          path: 'training_schedules',
          name: 'training_schedules',
          children: [
            {
              path: '',
              name: 'training_schedules_index',
              component: () => import('@/views/training_schedules/IndexView.vue')
            },
            {
              path: ':training_schedule_uuid',
              name: 'training_schedules_show',
              component: () => import('@/views/training_schedules/ShowView.vue')
            },
            {
              path: ':training_schedule_uuid/training_attendances',
              name: 'training_schedule_training_attendance',
              component: () => import('@/views/training_attendances/ShowView.vue')
            },
            {
              path: 'create',
              name: 'training_schedules_create',
              component: () => import('@/views/training_schedules/CreateView.vue')
            }
          ]
        },
        {
          path: 'training_courses',
          name: 'training_courses',
          children: [
            {
              path: ':training_courses_uuid',
              name: 'training_courses_show',
              component: () => import('@/views/training_courses/ShowView.vue')
            }
          ]
        }
      ]
    },
    {
      path: '/profile',
      name: 'profile',
      children: [
        {
          path: '',
          name: 'profile_show',
          component: () => import('@/views/profile/ProfileView.vue'),
          props: true
        },

        {
          path: ':uuid/edit',
          name: 'profile_edit',
          component: () => import('@/views/profile/EditView.vue'),
          props: true
        }
      ]
    },
    {
      path: '/faqs',
      name: 'faq',
      component: () => import('@/views/faqs/FaqView.vue')
    },
    {
      path: '/grow_za/profile/:uuid/edit',
      name: 'grow_sa_profile_edit',
      component: () => import('~/src/views/farmers/partners/grow/edit/EditView.vue'),
      props: true
    },
    {
      path: '/preferences',
      name: 'preferences',
      children: [
        {
          path: '',
          name: 'preferences_show',
          component: () => import('@/views/preferences/PreferencesView.vue')
        },
        {
          path: 'marketing_clauses',
          name: 'marketing_clauses',
          component: () => import('@/views/preferences/partners/sbg/MarketClausesView.vue')
        }
      ]
    }
  ]
})

// This has been commented out for testing reasons
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  // if user does not exist then redirect to login screen
  if (!userStore.user && !to.path.includes('auth')) {
    const isHomeRoute = to.path === '' || to.path === '/' || to.name === 'home'
    if (to.query.grow !== undefined || isHomeRoute) next( { name: 'welcome', query: to.query } )
  }
  else next()

  // if user has been fetched and no partner selected redirect to select partner page
  // if (userStore.user && !userStore.partner && to.name !== 'select_partner') {
  //   return { name: 'select_partner' }
  // }

  // if user exists and partner has been selected and still on auth pages redirect to home
  // if (userStore.user && userStore.partner && to.path.includes('auth')) {
  //   return { name: 'home' }
  // }
})

export default router
